<div class="bg-grey main-container">
  <common-simple-search class="d-lg-none"></common-simple-search>
  <section class="hero-background" role="img" aria-label="[equipment make and model] sitting idle and waiting to be rented on Rubbl">
    <div class="container-sm">
      <div class="row">
        <div class="my-5 mx-4 mx-lg-4">
          <div>
            <h1 class="jumbotron-header text-white">Increase your utilization. Earn revenue doing it.</h1>
            <p class="subhead-2 text-white">
              Get your idle machines rented by contractors who need them. Always risk-free to you, we only get paid when your gear is rented.
            </p>
          </div>
          <div>
            <a class="btn btn-primary btn-lg" [routerLink]="['/signup']" [queryParams]="{ capability: 'owner' }" [skipLocationChange]="true">Get Started</a>
          </div>
          <div class="my-4 mb-lg-0 d-inline-flex align-items-center cursor-pointer" (click)="watchVideo()">
            <i class="icon-play-button rounded-circle"></i>
            <p class="call-out-text text-white ml-3">WATCH VIDEO</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
